import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDate',
    standalone: true
})
export class FormatDatePipe implements PipeTransform {

    transform(value: string | undefined): string {
        if (!value) return '';

        const date = new Date(value);
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        };

        return date.toLocaleString('de-DE', options);
    }

}
